var _defs, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiniLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.076,
    height: 28.751,
    viewBox: "0 0 157.673 41.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003b83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))), /*#__PURE__*/React.createElement("g", {
    fontWeight: 400,
    letterSpacing: 0,
    wordSpacing: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "noc",
    style: {
      lineHeight: 1.25
    },
    fontSize: 25.613,
    fontFamily: "Hashtag",
    strokeWidth: 0.325
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.593-8.19q-.247-.433-.247-.37.061.061-.31-.062h-.186q-.62 0-.929-.124-.31-.124-.433-.248-.124-.124.371-.433.124-.062 0-.186t0-.186q.124-.124.062-.247-.062-.124.062-.248.31-.248.31-.62.061-.37.31-.495l2.29-.743V-4.1q0 2.725.062 5.45.124 2.662.31 5.449.186 2.725.62 5.697.061.372.061.867.062.496.062.991l.062.248q-.124-.124-.248-.31-.062-.185-.124-.495-.929 1.424-1.858 1.362-.867-.061-1.734-1.238-.062.31-.185.495-.062.124-.062.248.124-1.053 0-2.106-.062-1.114-.062-2.167 0-1.982-.062-3.53 0-1.61.062-3.53.062-2.972.743-6.193.681-3.282 2.106-6.007 1.424-2.786 3.653-4.52 2.292-1.796 5.636-1.796 3.84 0 5.883 1.796 2.044 1.795 2.972 4.52.93 2.663 1.115 5.822.248 3.096.496 5.697l.247 3.096q.124 1.548.372 3.097.31 1.486.743 2.972T107 14.663q.124.124.186.31.062.185.186.31.062.061 0 .185-.062.062 0 .062.557 0 .99.185.434.186.806-.061.557-.31 1.238-.372.743-.124 1.425-.495.433-.186.619.247.247.372-.186.62-.681.31-.99.99-.248.744-.806 1.053-.743.496-1.424 1.115-.62.62-1.672.62-1.548 0-2.663-1.177-1.115-1.115-1.92-2.725-.805-1.61-1.238-3.282-.434-1.734-.62-2.787-.495-2.849-.68-5.698-.125-2.91-.372-5.82-.124-1.363-.372-2.973-.186-1.61-.805-2.973-.62-1.424-1.734-2.291-1.115-.929-3.034-.929-2.23 0-3.654 1.177Q88.857-8.87 87.99-6.95q-.867 1.92-1.239 4.335-.372 2.353-.495 4.768-.124 2.416-.124 4.583.061 2.167.061 3.654 0 .557.062 1.424.062.805.062 1.672 0 .805-.124 1.61-.124.743-.434 1.239-.433.681-1.114.867-.62.247-1.3.062-.62-.186-1.115-.744-.434-.557-.496-1.424l-.062-.433q-.061-.372-.061-.805 0-.434-.062-.744-.434-3.034-.496-5.883-.061-2.848 0-5.573l.248-5.574q.124-2.848.124-5.82.557.37.805.557.248.185.433.371l.372.248.557.371z",
    style: {
      InkscapeFontSpecification: "Hashtag"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.168-6.022q-.495-.062-.805 0-.247.062-.743.062-1.858 0-3.034 1.177-1.177 1.176-1.858 2.91-.681 1.734-.99 3.654-.248 1.92-.248 3.406 0 1.362.619 2.477.681 1.053 1.734 1.858 1.053.743 2.291 1.238 1.239.434 2.477.558 2.292.247 4.211-.31 1.92-.62 3.283-1.734 1.424-1.177 2.167-2.849.805-1.672.805-3.653 0-4.335-2.167-7.06-2.106-2.725-6.193-2.725-.867 0-1.486-.124-.62-.124-1.425-.062-.557.062-.619-.495-.062-.557.495-.62.867-.123 1.487-.495.68-.433 1.548-.433 2.787 0 5.078.805 2.291.743 3.901 2.291 1.672 1.548 2.54 3.778.928 2.23.928 5.14 0 2.91-1.114 5.387-1.115 2.416-3.097 4.212-1.981 1.734-4.768 2.6-2.725.867-6.007.558-1.858-.186-3.716-1.053-1.796-.867-3.22-2.23-1.424-1.362-2.353-3.158-.867-1.796-.867-3.901 0-1.796.619-3.963.681-2.23 1.92-4.088 1.238-1.92 2.972-3.158 1.796-1.3 4.087-1.3.558 0 .867.185.31.124.806.248.247 0 .31.186.123.124.061.31 0 .185-.124.309t-.371.062z",
    style: {
      InkscapeFontSpecification: "Hashtag"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.952-4.474q-.062-.124.124-.31.248-.247.062-.247-2.106 0-4.15 1.363-2.043 1.3-3.715 3.282-1.61 1.981-2.6 4.335-.992 2.291-.992 4.273 0 .929.496 1.424.557.434 1.3.681.805.186 1.61.248.867.062 1.549.186 2.105 0 4.396-.124 2.354-.186 4.645-.62 2.353-.495 4.459-1.362 2.105-.929 3.777-2.353.31-.31.62.061.31.31-.062.62-1.548 1.362-3.282 2.724-1.672 1.363-3.53 2.478-1.858 1.114-3.84 1.92-1.981.742-4.087.866-.929.124-1.672.124-.681-.061-1.61-.061h-.186q-1.61-.31-2.91-.434-1.3-.186-2.787-.929-1.548-.743-2.292-2.23-.68-1.485-.68-3.22 0-2.539 1.424-5.325 1.424-2.849 3.653-5.202 2.23-2.415 4.955-3.964 2.786-1.548 5.511-1.548 1.982 0 2.849.62.929.557 1.053 1.362.124.805-.31 1.61-.434.743-1.115 1.115-.681.371-1.486.124-.743-.248-1.177-1.486z",
    style: {
      InkscapeFontSpecification: "Hashtag"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      lineHeight: 1.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.42-15.975V-4.68H56.471q-1.315 8.045-2.166 18.643t-.851 16.942q0 6.807 2.707 10.056 2.785 3.172 6.963 3.172 3.404 0 5.724-2.166 2.321-2.166 2.785-6.42h2.785Q73.027 47.15 68.54 52.1q-4.486 4.951-10.056 4.951-5.724 0-9.67-5.338-3.868-5.415-3.868-21.428 0-7.04.851-15.781Q47.111.348 47.886-4.68h-18.18l-1.702 23.594Q25.993 37.403 23.13 47.46q-1.547 5.57-4.796 8.277-1.47 1.315-3.636 1.315-3.017 0-5.028-1.934-1.934-1.857-1.934-4.487 0-2.166.773-4.022.465-1.16 4.255-6.421 2.553-3.481 3.945-7.504 1.393-4.023 2.553-13.074.233-1.624 1.857-24.29h-2.243q-5.416 0-8.82 2.166Q6.654-.348 2.786 6.227H0Q2.475-3.056 6.266-8.084q3.79-5.028 7.35-6.42 3.558-1.47 11.448-1.47z",
    style: {
      InkscapeFontSpecification: "Onyx"
    },
    fontFamily: "Onyx",
    "aria-label": "\\u03C0",
    fontSize: 37.444,
    opacity: 0.647,
    strokeWidth: 0.936
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.697 4.11l24.59-15.787-10.285 62.975m10.285-62.975l27.567 1.01m10.653 61.34l-13.729-5.75m0 0l3.076-55.59m19.518-.719l-19.518.719",
    fill: "none",
    stroke: "#fcffff",
    strokeWidth: 0.2552728
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 0.335,
    cy: 66.656,
    cx: 257.22,
    fill: "#fff",
    stroke: "#fcffff",
    strokeWidth: 0.028,
    transform: "matrix(2.0924 0 0 2.0924 -536.511 -135.366)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 0.335,
    cy: 66.656,
    cx: 257.22,
    fill: "#fff",
    stroke: "#fcffff",
    strokeWidth: 0.028,
    transform: "matrix(2.0924 0 0 2.0924 -511.92 -151.153)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 0.335,
    cy: 66.656,
    cx: 257.22,
    fill: "#fff",
    stroke: "#fcffff",
    strokeWidth: 0.028,
    transform: "matrix(2.0924 0 0 2.0924 -522.206 -88.18)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 0.335,
    cy: 66.656,
    cx: 257.22,
    fill: "#fff",
    stroke: "#fcffff",
    strokeWidth: 0.028,
    transform: "matrix(2.0924 0 0 2.0924 -487.43 -94.553)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 0.335,
    cy: 66.656,
    cx: 257.22,
    fill: "#fff",
    stroke: "#fcffff",
    strokeWidth: 0.028,
    transform: "matrix(2.0924 0 0 2.0924 -473.701 -88.803)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 0.335,
    cy: 66.656,
    cx: 257.22,
    fill: "#fff",
    stroke: "#fcffff",
    strokeWidth: 0.028,
    transform: "matrix(2.0924 0 0 2.0924 -484.354 -150.144)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 0.335,
    cy: 66.656,
    cx: 257.22,
    fill: "#fff",
    stroke: "#fcffff",
    strokeWidth: 0.028,
    transform: "matrix(2.0924 0 0 2.0924 -464.836 -150.862)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini_logo.0c6284bff20ca21f5730d8f8dfc4193b.svg";
export { ForwardRef as ReactComponent };